// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './vuex/store'
import Element from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import axios from 'axios'
import Gsui from './assets/gs/gs-ui.js'
import './assets/gs/gs-ui.css'
import $ from 'jquery'
import '../static/jquery-3.3.1.min'
import '../static/jquery.ztree.core.min'
import '../static/jquery.ztree.excheck.min'
import '../static/jquery.ztree.exedit.min'
import '../static/jquery.ztree.exhide.min'
import '../static/fuzzysearch'
import '../static/zTreeStyle.css'
import '../src/components/datePicker/style.scss'
import 'vx-easyui/dist/themes/bootstrap/easyui.css'
import 'vx-easyui/dist/themes/icon.css'
import 'vx-easyui/dist/themes/vue.css'
import '../static/mainStyle.css'
import EasyUI from 'vx-easyui'
import './style/main.css'
import flvjs from 'flv.js/dist/flv.min'
import scroll from 'vue-seamless-scroll'
import 'echarts-liquidfill'
import echarts from 'echarts'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
import VueParticles from 'vue-particles'
import VueCron from 'vue-cron'
import BaiduMap from 'vue-baidu-map'
/* import 'default-passive-events' */
import VueDragResize from 'vue-drag-resize'
import vdrag from './directive/drag';
import dialogDrag from './directive/dialogDrag';
Vue.directive('drag', vdrag);
Vue.directive('dialogDrag', vdrag);

Vue.component('vue-drag-resize', VueDragResize)

/* vue2 */

Vue.use(BaiduMap, {
  ak: 'FhXgL7WF7vKGisv3tu2WFcPuQ7IaCTfn'
})

Vue.use(VueCron)
Vue.use(VueParticles)
Vue.use(VueAwesomeSwiper)
Vue.prototype.$echarts = echarts
Vue.use(scroll)
Vue.use(flvjs)
Vue.use(EasyUI)
Vue.use(Element)
Vue.use(Gsui)
Vue.config.productionTip = false
Vue.prototype.$ajax = axios
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store: store,
  components: {
    App
  },
  template: '<App/>'
})




// WEBPACK FOOTER //
// ./src/main.js